'use client'

import { useTranslations } from 'next-intl'
import Image from 'next/image'
import type { QuestionDef } from '@lib/survey-questions'
import type { SectionAnswers } from '@lib/models/types'
import { QUESTION_IMAGES } from '@lib/models/maps'
import { RadioGroup } from '@components/forms/RadioGroup/RadioGroup'

export function SectionPage({
  sectionKey,
  questions,
  answers,
  onAnswer,
}: {
  sectionKey: string
  questions: QuestionDef[]
  answers: SectionAnswers
  onAnswer: (key: string, value: string) => void
}) {
  const t = useTranslations('survey.pages')

  return (
    <div id={`section-page-${sectionKey}`}>
      <h2 id={`section-page-${sectionKey}-title`} className="mb-2">
        {t(`${sectionKey}.title` as Parameters<typeof t>[0])}
      </h2>
      <p id={`section-page-${sectionKey}-description`} className="text-black mb-6 text-sm">
        {t(`${sectionKey}.description` as Parameters<typeof t>[0])}
      </p>
      {questions.map((q) => {
        const imageConfig = QUESTION_IMAGES[`${sectionKey}.${q.key}`]
        return (
          <RadioGroup
            key={q.key}
            name={q.key}
            label={t(`${sectionKey}.${q.key}` as Parameters<typeof t>[0])}
            choices={q.choiceKeys.map((ck) => ({
              key: ck,
              label: t(`${sectionKey}.${q.key}Choices.${ck}` as Parameters<typeof t>[0]),
            }))}
            value={answers[q.key] ?? ''}
            onChange={(val) => onAnswer(q.key, val)}
            beforeLegend={imageConfig ? (
              <div id={`section-page-${sectionKey}-${q.key}-image`} className="mb-4 flex flex-col items-center">
                <Image
                  src={imageConfig.src}
                  alt={t(imageConfig.descKey as Parameters<typeof t>[0])}
                  width={400}
                  height={300}
                  className="rounded-lg w-full max-w-sm"
                />
                <p id={`section-page-${sectionKey}-${q.key}-image-caption`} className="text-black text-xs mt-2 text-center max-w-sm italic">
                  {t(imageConfig.descKey as Parameters<typeof t>[0])}
                </p>
              </div>
            ) : undefined}
          />
        )
      })}
    </div>
  )
}
